import React, { useState } from "react";
import Navbar from "../components/sub-comp/Navbar.jsx";
import Footer from "../components/sub-comp/MainFooter.jsx";
import FloatingSocialPanels from "../components/sub-comp/FloatingSocialPanels";
import campusDrone from "../assets/JR INSTITUTE DRONE.mp4";
import {
  FaMapMarkerAlt,
  FaPhone,
  FaEnvelope,
  FaCalendarAlt,
  FaClock,
  FaUsers,
  FaCamera,
  FaPlay,
  FaArrowRight,
  FaWifi,
  FaParking,
  FaUtensils,
  FaBook,
  FaLaptop,
  FaMicroscope,
  FaGamepad,
  FaSwimmingPool,
  FaDumbbell,
  FaGraduationCap,
  FaChevronLeft,
  FaChevronRight,
} from "react-icons/fa";

const CampusTour = () => {
  const [selectedTour, setSelectedTour] = useState("virtual");
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const tourOptions = [
    {
      id: "virtual",
      title: "Virtual Campus Tour",
      description:
        "Explore our campus from anywhere in the world with our interactive 360° virtual tour.",
      duration: "15-20 minutes",
      icon: FaPlay,
      features: [
        "360° Interactive Views",
        "Audio Commentary",
        "Available 24/7",
        "Mobile Friendly",
      ],
      buttonText: "Start Virtual Tour",
      buttonAction: () =>
        window.open("https://example.com/virtual-tour", "_blank"),
    },
    {
      id: "in-person",
      title: "In-Person Campus Visit",
      description:
        "Schedule a personalized campus visit with our admissions team and current students.",
      duration: "2-3 hours",
      icon: FaUsers,
      features: [
        "Personalized Tour",
        "Meet Faculty & Students",
        "Q&A Session",
        "Campus Facilities",
      ],
      buttonText: "Schedule Visit",
      buttonAction: () => setSelectedTour("in-person"),
    },
    {
      id: "group",
      title: "Group Tours",
      description:
        "Perfect for schools, organizations, and large groups interested in our programs.",
      duration: "1-2 hours",
      icon: FaUsers,
      features: [
        "Customized Experience",
        "Program Presentations",
        "Campus Facilities",
        "Lunch Options",
      ],
      buttonText: "Book Group Tour",
      buttonAction: () => setSelectedTour("group"),
    },
  ];

  const campusHighlights = [
    {
      id: 1,
      name: "Main Academic Building",
      description:
        "State-of-the-art classrooms, computer labs, and lecture halls equipped with modern technology.",
      image:
        "https://images.unsplash.com/photo-1562774053-701939374585?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80",
      features: [
        "Smart Classrooms",
        "Computer Labs",
        "Lecture Halls",
        "Study Areas",
      ],
    },
    {
      id: 2,
      name: "Library & Learning Center",
      description:
        "Comprehensive library with digital resources, study spaces, and research facilities.",
      image:
        "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80",
      features: [
        "Digital Resources",
        "Study Rooms",
        "Research Facilities",
        "24/7 Access",
      ],
    },
    {
      id: 3,
      name: "Student Center",
      description:
        "Hub of student life with dining facilities, recreational areas, and student services.",
      image:
        "https://images.unsplash.com/photo-1523050854058-8df90110c9f1?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80",
      features: [
        "Cafeteria",
        "Student Lounge",
        "Game Room",
        "Student Services",
      ],
    },
    {
      id: 4,
      name: "Sports Complex",
      description:
        "Modern athletic facilities including gymnasium, outdoor courts, and fitness center.",
      image:
        "https://images.unsplash.com/photo-1571019613454-1cb2f99b2d8b?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80",
      features: [
        "Gymnasium",
        "Fitness Center",
        "Outdoor Courts",
        "Swimming Pool",
      ],
    },
    {
      id: 5,
      name: "Computer Labs",
      description:
        "Advanced computer laboratories with latest hardware and software for hands-on learning.",
      image:
        "https://images.unsplash.com/photo-1518709268805-4e9042af2176?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80",
      features: [
        "Latest Hardware",
        "Professional Software",
        "High-Speed Internet",
        "24/7 Access",
      ],
    },
    {
      id: 6,
      name: "Research Center",
      description:
        "Dedicated research facilities for advanced studies and innovation projects.",
      image:
        "https://images.unsplash.com/photo-1581091226825-a6a2a5aee158?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80",
      features: [
        "Research Labs",
        "Innovation Hub",
        "Collaboration Spaces",
        "Advanced Equipment",
      ],
    },
  ];

  const campusPhotos = [
    {
      id: 1,
      src: "https://images.unsplash.com/photo-1562774053-701939374585?ixlib=rb-4.0.3&auto=format&fit=crop&w=1200&q=80",
      alt: "Main Campus Building",
      title: "Main Campus Building",
    },
    {
      id: 2,
      src: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?ixlib=rb-4.0.3&auto=format&fit=crop&w=1200&q=80",
      alt: "Library Interior",
      title: "Library Interior",
    },
    {
      id: 3,
      src: "https://images.unsplash.com/photo-1523050854058-8df90110c9f1?ixlib=rb-4.0.3&auto=format&fit=crop&w=1200&q=80",
      alt: "Student Center",
      title: "Student Center",
    },
    {
      id: 4,
      src: "https://images.unsplash.com/photo-1571019613454-1cb2f99b2d8b?ixlib=rb-4.0.3&auto=format&fit=crop&w=1200&q=80",
      alt: "Sports Complex",
      title: "Sports Complex",
    },
    {
      id: 5,
      src: "https://images.unsplash.com/photo-1518709268805-4e9042af2176?ixlib=rb-4.0.3&auto=format&fit=crop&w=1200&q=80",
      alt: "Computer Laboratory",
      title: "Computer Laboratory",
    },
    {
      id: 6,
      src: "https://images.unsplash.com/photo-1581091226825-a6a2a5aee158?ixlib=rb-4.0.3&auto=format&fit=crop&w=1200&q=80",
      alt: "Research Center",
      title: "Research Center",
    },
  ];

  const nextImage = () => {
    setCurrentImageIndex((prev) => (prev + 1) % campusPhotos.length);
  };

  const prevImage = () => {
    setCurrentImageIndex(
      (prev) => (prev - 1 + campusPhotos.length) % campusPhotos.length,
    );
  };

  const openModal = (index) => {
    setCurrentImageIndex(index);
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
  };

  return (
    <div>
      <Navbar />

      {/* Hero Section with Background Video */}
      <section className="relative text-white py-20 lg:py-32 overflow-hidden">
        <video
          className="absolute inset-0 w-full h-full object-cover"
          src={campusDrone}
          autoPlay
          loop
          muted
          playsInline
        />
        <div className="absolute inset-0 bg-black/40" />
        <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h1 className="text-4xl sm:text-5xl lg:text-6xl font-bold mb-6">
            Discover Our Campus
          </h1>
          <p className="text-xl sm:text-2xl mb-8 max-w-3xl mx-auto">
            Experience the vibrant community and world-class facilities that
            make JR Institute the perfect place for your educational journey.
          </p>
          <div className="flex flex-wrap justify-center gap-8 text-center">
            <div className="flex items-center gap-2">
              <FaMapMarkerAlt className="text-gold text-2xl" />
              <span className="text-lg font-semibold">Arusha, Tanzania</span>
            </div>
            <div className="flex items-center gap-2">
              <FaCalendarAlt className="text-gold text-2xl" />
              <span className="text-lg font-semibold">
                Tours Available Daily
              </span>
            </div>
            <div className="flex items-center gap-2">
              <FaUsers className="text-gold text-2xl" />
              <span className="text-lg font-semibold">
                Personalized Experience
              </span>
            </div>
          </div>
        </div>
      </section>

      {/* Tour Options */}
      <section className="py-16 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-3xl sm:text-4xl font-bold text-custom-pink mb-4">
              Choose Your Tour Experience
            </h2>
            <p className="text-lg text-gray-600 max-w-3xl mx-auto">
              Whether you prefer to explore virtually or visit us in person, we
              have the perfect tour option for you.
            </p>
          </div>

          <div className="grid md:grid-cols-3 gap-8">
            {tourOptions.map((tour) => {
              const IconComponent = tour.icon;
              return (
                <div
                  key={tour.id}
                  className={`bg-white rounded-xl shadow-lg p-8 transition-all duration-300 cursor-pointer ${selectedTour === tour.id
                      ? "ring-2 ring-custom-pink shadow-xl transform scale-105"
                      : "hover:shadow-xl hover:scale-105"
                    }`}
                  onClick={() => setSelectedTour(tour.id)}
                >
                  <div className="text-center mb-6">
                    <div className="bg-custom-pink text-white p-4 rounded-full w-16 h-16 mx-auto mb-4 flex items-center justify-center">
                      <IconComponent className="text-2xl" />
                    </div>
                    <h3 className="text-xl font-bold text-gray-900 mb-2">
                      {tour.title}
                    </h3>
                    <p className="text-gray-600 mb-4">{tour.description}</p>
                    <div className="flex items-center justify-center gap-2 text-sm text-gold font-semibold">
                      <FaClock className="text-sm" />
                      <span>{tour.duration}</span>
                    </div>
                  </div>

                  <ul className="space-y-2 mb-6">
                    {tour.features.map((feature, index) => (
                      <li
                        key={index}
                        className="flex items-center gap-2 text-sm text-gray-600"
                      >
                        <div className="w-2 h-2 bg-gold rounded-full"></div>
                        {feature}
                      </li>
                    ))}
                  </ul>

                  <button
                    onClick={(e) => {
                      e.stopPropagation();
                      tour.buttonAction();
                    }}
                    className="w-full bg-gold text-white py-3 px-6 rounded-lg hover:bg-custom-pink transition-colors duration-300 font-semibold flex items-center justify-center gap-2"
                  >
                    {tour.buttonText}
                    <FaArrowRight className="text-sm" />
                  </button>
                </div>
              );
            })}
          </div>
        </div>
      </section>

      {/* Campus Highlights */}
      <section className="py-16 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-3xl sm:text-4xl font-bold text-custom-pink mb-4">
              Campus Highlights
            </h2>
            <p className="text-lg text-gray-600">
              Explore our state-of-the-art facilities and modern learning
              environments.
            </p>
          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
            {campusHighlights.map((highlight) => (
              <div
                key={highlight.id}
                className="bg-white rounded-xl shadow-lg overflow-hidden hover:shadow-xl transition-shadow duration-300"
              >
                <div className="relative h-48 overflow-hidden">
                  <img
                    src={highlight.image}
                    alt={highlight.name}
                    className="w-full h-full object-cover hover:scale-105 transition-transform duration-300"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/50 to-transparent"></div>
                </div>
                <div className="p-6">
                  <h3 className="text-xl font-bold text-gray-900 mb-2">
                    {highlight.name}
                  </h3>
                  <p className="text-gray-600 mb-4">{highlight.description}</p>
                  <div className="space-y-2">
                    {highlight.features.map((feature, index) => (
                      <div
                        key={index}
                        className="flex items-center gap-2 text-sm text-gray-500"
                      >
                        <div className="w-1.5 h-1.5 bg-gold rounded-full"></div>
                        {feature}
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Campus Photo Gallery */}
      <section className="py-16 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-3xl sm:text-4xl font-bold text-custom-pink mb-4">
              Campus Photo Gallery
            </h2>
            <p className="text-lg text-gray-600">
              Take a visual journey through our beautiful campus and facilities.
            </p>
          </div>

          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
            {campusPhotos.map((photo, index) => (
              <div
                key={photo.id}
                className="relative h-48 overflow-hidden rounded-lg cursor-pointer group"
                onClick={() => openModal(index)}
              >
                <img
                  src={photo.src}
                  alt={photo.alt}
                  className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-300"
                />
                <div className="absolute inset-0 bg-black/0 group-hover:bg-black/30 transition-colors duration-300 flex items-center justify-center">
                  <FaCamera className="text-white text-2xl opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Visit Information & Contact */}
      <section className="py-16 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid lg:grid-cols-2 gap-12">
            {/* Visit Information */}
            <div>
              <h2 className="text-3xl sm:text-4xl font-bold text-custom-pink mb-6">
                Plan Your Visit
              </h2>

              <div className="space-y-6">
                <div className="flex items-start gap-4">
                  <div className="bg-gold text-white p-3 rounded-full">
                    <FaCalendarAlt className="text-xl" />
                  </div>
                  <div>
                    <h3 className="text-xl font-bold text-gray-900 mb-2">
                      Tour Schedule
                    </h3>
                    <div className="space-y-1 text-gray-600">
                      <p>
                        <strong>Monday - Friday:</strong> 9:00 AM - 4:00 PM
                      </p>
                      <p>
                        <strong>Saturday:</strong> 10:00 AM - 2:00 PM
                      </p>
                      <p>
                        <strong>Sunday:</strong> By appointment only
                      </p>
                    </div>
                  </div>
                </div>

                <div className="flex items-start gap-4">
                  <div className="bg-gold text-white p-3 rounded-full">
                    <FaClock className="text-xl" />
                  </div>
                  <div>
                    <h3 className="text-xl font-bold text-gray-900 mb-2">
                      What to Expect
                    </h3>
                    <ul className="space-y-1 text-gray-600">
                      <li>• Campus facilities tour</li>
                      <li>• Meet with admissions staff</li>
                      <li>• Q&A with current students</li>
                      <li>• Program-specific information</li>
                    </ul>
                  </div>
                </div>

                <div className="flex items-start gap-4">
                  <div className="bg-gold text-white p-3 rounded-full">
                    <FaUsers className="text-xl" />
                  </div>
                  <div>
                    <h3 className="text-xl font-bold text-gray-900 mb-2">
                      Group Tours
                    </h3>
                    <p className="text-gray-600">
                      Special arrangements available for schools, organizations,
                      and groups of 10 or more. Please contact us at least one
                      week in advance.
                    </p>
                  </div>
                </div>
              </div>
            </div>

            {/* Contact Information */}
            <div>
              <h2 className="text-3xl sm:text-4xl font-bold text-custom-pink mb-6">
                Contact Admissions
              </h2>

              <div className="space-y-6">
                <div className="flex items-center gap-4">
                  <div className="bg-custom-pink text-white p-3 rounded-full">
                    <FaPhone className="text-xl" />
                  </div>
                  <div>
                    <h3 className="text-lg font-bold text-gray-900">Phone</h3>
                    <p className="text-gray-600">+255 22 123 4567</p>
                  </div>
                </div>

                <div className="flex items-center gap-4">
                  <div className="bg-custom-pink text-white p-3 rounded-full">
                    <FaEnvelope className="text-xl" />
                  </div>
                  <div>
                    <h3 className="text-lg font-bold text-gray-900">Email</h3>
                    <p className="text-gray-600">admissions@jriit.ac.tz</p>
                  </div>
                </div>

                <div className="flex items-start gap-4">
                  <div className="bg-custom-pink text-white p-3 rounded-full">
                    <FaMapMarkerAlt className="text-xl" />
                  </div>
                  <div>
                    <h3 className="text-lg font-bold text-gray-900">Address</h3>
                    <p className="text-gray-600">
                      JR Institute of Information Technology
                      <br />
                      Admissions Office
                      <br />
                      Arusha
                      <br />
                      P.O. Box 12345
                    </p>
                  </div>
                </div>
              </div>

              {/* Quick Actions */}
              <div className="mt-8 space-y-4">
                <button className="w-full bg-gold text-white py-3 px-6 rounded-lg hover:bg-custom-pink transition-colors duration-300 font-semibold">
                  Schedule Your Visit
                </button>
                <button className="w-full border-2 border-custom-pink text-custom-pink py-3 px-6 rounded-lg hover:bg-custom-pink hover:text-white transition-colors duration-300 font-semibold">
                  Download Campus Map
                </button>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Image Modal */}
      {isModalOpen && (
        <div className="fixed inset-0 bg-black/80 z-50 flex items-center justify-center p-4">
          <div className="relative max-w-4xl max-h-full">
            <button
              onClick={closeModal}
              className="absolute top-4 right-4 text-white text-2xl hover:text-gold transition-colors z-10"
            >
              ×
            </button>
            <img
              src={campusPhotos[currentImageIndex].src}
              alt={campusPhotos[currentImageIndex].alt}
              className="max-w-full max-h-full object-contain rounded-lg"
            />
            <div className="absolute bottom-4 left-1/2 transform -translate-x-1/2 flex gap-2">
              <button
                onClick={prevImage}
                className="bg-white/20 text-white p-2 rounded-full hover:bg-white/40 transition-colors"
              >
                <FaChevronLeft />
              </button>
              <button
                onClick={nextImage}
                className="bg-white/20 text-white p-2 rounded-full hover:bg-white/40 transition-colors"
              >
                <FaChevronRight />
              </button>
            </div>
          </div>
        </div>
      )}

      <Footer />
      <FloatingSocialPanels />
    </div>
  );
};

export default CampusTour;








